import React, { useEffect } from "react";
import "./Check_your_fit.css";
import QuoteSection from "./quoteSection/QuoteSection";
import InfoCards from "./infoCards/InfoCards";
import CoursesSection from "./coursesSection/CoursesSection";
import OpportunitySection from "./opportunitySection/OpportunitySection";
import Features from "./features/Features";
import For_support from "../for-support/For_support";

function Check_your_fit() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <section className="checkyourfit_section">
      <QuoteSection />
      <InfoCards />
      <CoursesSection />
      <OpportunitySection />
      <Features />
      <For_support />
    </section>
  );
}

export default Check_your_fit;
